import { jsx } from "panel";
import { LineChartEl } from "common/charts/visualization/line-chart";
import { SegmentLegendHeaderEl } from "common/charts/misc/segment-legend-header";
function ChartSubtitleText({ subtitleText }) {
  return /* @__PURE__ */ jsx("div", {
    sel: ".header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".labels"
  }, (() => {
    return subtitleText ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("span", {
      sel: ".description.mp-font-weight-medium"
    }, subtitleText.totalInStepText), /* @__PURE__ */ jsx("span", {
      sel: ".conversion-amount"
    }, subtitleText.conversionText)) : null;
  })()));
}
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".root"
  }, this.attr(`include-header`) && this.helpers.subtitleText() ? /* @__PURE__ */ jsx(ChartSubtitleText, {
    subtitleText: this.helpers.subtitleText()
  }) : null, /* @__PURE__ */ jsx(SegmentLegendHeaderEl, {
    sel: ".segment-header"
  }), /* @__PURE__ */ jsx(LineChartEl, {
    sel: ".line-chart",
    attrs: this.helpers.getLineChartAttrs(),
    props: this.helpers.getLineChartProps()
  }));
}
